// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"213":"48960f67","453":"d0d8a74e","732":"22d20175"}[chunkId] + ".chunk.js");